import { render, staticRenderFns } from "./TrainPartLoading.vue?vue&type=template&id=3686129c&scoped=true&"
import script from "./TrainPartLoading.vue?vue&type=script&lang=js&"
export * from "./TrainPartLoading.vue?vue&type=script&lang=js&"
import style0 from "./TrainPartLoading.vue?vue&type=style&index=0&id=3686129c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3686129c",
  null
  
)

export default component.exports